import Icon from '../components/Icon.vue'

Icon.register({
  'volleyball-ball': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M231.4 243.5c-60.9 37.4-126.3 123.5-146.1 192.2-20.2-19.2-45.7-55.5-56.9-81.1 22.8-94.4 89.5-174.4 180.3-216.8 11.9 28 22.1 75.3 22.7 105.7zM194.5 109.1c-84 39.5-149 108.4-182.4 191.5-19.8-109.3 34-212.4 125-262.2 19 16.9 44.7 48.6 57.4 70.7zM382.1 274.2c-30.2-3.7-76.3-18.5-102.9-33.2-2-71.5-43.8-171.3-93.5-222.7 47.3-14 84.2-10.2 98.9-8.5 70.2 66.9 106.1 164.6 97.5 264.4zM257.4 283.7c49.7 26.8 104 40.8 158.6 40.9 22.7-0.1 58.9-4.8 80.9-10.4-6.6 27.2-25.5 67.5-42.2 89.9-93 27.3-195.5 9.5-277.5-47.8 18.3-24.3 54.2-56.8 80.2-72.6zM159.1 383.4c53.6 37.3 144 78.2 256.9 62.1-38.2 32.3-109.7 58.6-159.8 58.6-38.5 0-96.4-16.4-129.2-36.5 6.4-29.8 16.9-58.2 32.1-84.2zM339.4 22.8c95.9 34.3 164.6 125.6 164.6 233.4 0 2-0.3 4-0.3 6-24 7.8-63.9 14.2-89.1 14.2-0.2 0-0.4 0-0.6 0 7.9-92.4-19.3-183.2-74.6-253.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volleyball-ball.js
// module id = 2092
// module chunks = 0